/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-29 16:08:12
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-11-02 13:05:09
 */
export default {
  '序号': '序號',
  '含扩容：': '含扩容：',
  'EPOS授权信息': 'EPOS授權信息',
  '汇总：': '匯總：',
  '剩余': '剩余',
  '店务': '店务',
  '绑定类型：': '綁定類型：',
  '剩余天数': '剩余天數',
  '操作': '操作',
  '查看': '查看',
  '店铺授权容量': '店鋪授權數量',
  'WEB授权容量': 'WEB授權數量',
  '移动授权容量': '移動授權數量',
  '合同编号': '合同編號',
  '开始/结束时间': '開始/結束時間',
  'Android平板': 'Android平板',
  'Android手机': 'Android手機',
  'IPhone': 'IPhone',
  'IPAD': 'IPAD',
  'WEB': 'WEB',
  '授权信息': '授權信息',
  '查看变更记录': '查看變更記錄',
  '店铺授权清单': '店鋪授權清單',
  '设备归属清单': '設備歸屬清單',
  '新增授权店铺': '新增授權店鋪',
  '管理所有店铺授权': '管理所有店鋪授權',
  '管理所有归属设备': '管理所有歸屬設備',
  '管理': '管理',
  '数量': '數量',
  '关闭': '關閉',
  '授权全部渠道': '授權全部渠道',
  '确认授权所有店铺？': '確認授權所有店鋪？',
  '操作日期': '操作日期',
  '类型': '類型',
  '操作内容': '操作內容',
  '操作人': '操作人',
  '店铺编号': '店鋪編號',
  '店铺简称': '店鋪簡稱',
  '店铺全称': '店鋪全稱',
  'WEB设备': 'WEB設備',
  '移动': '移動',
  '机器编号': '機器編號',
  '机器码': '機器碼',
  '设备类型': '設備類型',
  '绑定类型': '綁定類型',
  '绑定日期': '綁定日期',
  '状态': '狀態',
  '余量：': '余量：',
  '（含扩容：': '（含擴容：',
  '该店铺不存在或已授权': '該店鋪不存在或已授權',
  '请输入': '請輸入',
  '授权设备类型': '授權設備類型',
  '绑定状态': '綁定狀態',
  '请选择': '請選擇',
  '筛选': '篩選',
  '清空': '清空',
  '返回': '返回',
  '设备绑定列表': '設備綁定列表',
  '解除绑定': '解除綁定',
  '移出黑名单': '移出黑名單',
  '加入黑名单': '加入黑名單',
  '全选': '全選',
  '提示': '提示',
  '取消': '取消',
  '确定': '確定',
  '正常': '正常',
  '白名单': '白名單',
  '黑名单': '黑名單',
  '激活码': '激活碼',
  '安卓手机': '安卓手機',
  '安卓平板': '安卓平板',
  '禁用': '禁用',
  '启用': '啟用',
  'EPOS版本': 'EPOS版本',
  '企业': '企業',
  '企业编号': '企業編號',
  '设备机型': '設備機型',
  '调整限额': '調整限額',
  '系统版本号': '系統版本號',
  'EPOS版本号': 'EPOS版本號',
  '解除往期的激活码/店铺容量绑定，避免影响店铺pos数量超出限额，确认提示框提醒是否继续操作': '解除往期的激活碼/店鋪容量綁定，避免影響店鋪pos數量超出限額，確認提示框提醒是否繼續操作',
  '允许登陆pos': '允許登陸pos',
  '释放往期的激活码/店铺容量': '釋放往期的激活碼/店鋪容量',
  '限制登陆pos，需解除绑定激活码、解除店铺归属，是否继续操作': '限制登陸pos，需解除綁定激活碼、解除店鋪歸屬，是否繼續操作',
  '是否解除绑定': '是否解除綁定',
  '是否': '是否',
  '解绑成功': '解綁成功',
  '店铺授权': '店鋪授權',
  '新增店铺授权': '新增店鋪授權',
  '总量': '總量',
  '授权日期': '授權日期',
  '合同编号：': '合同編號：',
  '请输入合同编号': '請輸入合同編號',
  '店铺编号：': '店鋪編號：',
  '请输入店铺编号': '請輸入店鋪編號',
  '店铺授权列表': '店鋪授權列表',
  'WEB限额': 'WEB限額',
  'WEB限额余量': 'WEB限額余量',
  '移动限额': '移動限額',
  '移动限额余量': '移動限額余量',
  '解除授权': '解除授權',
  '扩容': '擴容',
  '移动扩容:': '移動擴容',
  'WEB扩容:': 'WEB擴容',
  '扩容成功': '擴容成功',
  '将影响已授权的店铺登录，是否确定调整': '將影響已授權的店鋪登錄，是否確定調整',
  '登录记录查看': '登錄記錄查看',
  '请输入收银员名称': '請輸入收銀員名稱',
  '请输入机器编号': '請輸入機器編號',
  '请输入版本号': '請輸入版本號',
  '至': '至',
  '开始日期': '開始日期',
  '已过期': '已過期',
  '未生效': '未生效',
  '不足一天': '不足壹天',
  '结束日期': '結束日期',
  '搜索': '搜索',
  '登录时间': '登錄時間',
  '收银员': '收銀員',
  '门店': '門店',
  '设备型号': '設備型號',
  '系统版本': '系統版本',
  '经纬度': '經緯度',
  '定位地址': '定位地址',
  '最近一周': '最近壹周',
  '最近一个月': '最近壹個月',
  '最近三个月': '最近三個月',
  'Iphone': 'Iphone',
  'Ipad': 'Ipad',
  'WEB已用': 'WEB已用',
  '移动已用': '移動已用',
  '收银': '收銀',
  '物流': '物流',
  '公告': '公告',
  '储位': '儲位',
  '其他': '其他',
  '授权模块': '授權模塊',
  '清理闲置设备': '清理閑置設備',
  '最近登录日期': '最近登錄日期',
  '未登录天数': '未登錄天數',
  '机器编码': '機器編碼',
  '未登录天数大于': '未登錄天數大於',
  '请输入店铺简称': '請輸入店鋪簡稱',
  '解除全部': '解除全部',
  '请输入或选择': '請輸入或選擇',
  '解绑全部': '解绑全部',
  '将批量解绑所有设备，是否确认操作': '將批量解綁所有設備，是否確認操作',
  // 4.2
  '设备变更记录': '設備變更記錄',
  '操作时间': '操作時間',
  '收营员编号': '收營員編號',
  '操作状态': '操作狀態',
  '请输入收银员帐号': '請輸入收銀員帐號',
  '设备解绑记录': '設備解綁記錄',
  '收银员帐号': '收銀員編號',
  '合同变更记录': '合同變更記錄',
  '不限': '不限',
  '设备归属列表': '設備歸屬列表',
  '创建合同': '創建合同',
  '合同初始化': '合同初始化',
  '更新设备授权': '更新設備授權',
  '更新店铺数量': '更新店鋪數量',
  '续约': '續約',
  '模块配置': '模塊配置',
  '更新Webpos数量': '更新Webpos數量',
  '移动POS数量': '移動POS數量',
  '授权店铺数量': '授權店鋪數量',
  '更新合同服务日期': '更新合同服務日期',
  '店铺': '店鋪',
  'Webpos最高限额': 'Webpos最高限額',
  '请输入限额': '請輸入限額',
  '移动POS限额': '移動POS限額',
  '请输入本期授权的店铺总量': '請輸入本期授權的店鋪總量',
  '请输入本期授权的数量': '請輸入本期授權的數量',
  '授权的数量必须为正整数': '授權的數量必須為正整數',
  'Webpos最高限额不能低于': 'Webpos最高限額不能低於',
  '不能低于': '不能低於',
  '归属店铺': '歸屬店鋪',
  '全部': '全部',
  '取消归属': '取消歸屬',
  'Webpos限额': 'Webpos限額',
  '合同类型': '合同類型',
  '租用': '租用',
  '购买': '购买',
  '导出': '導出',
  '文件大小不能超过1M！': '文件大小不能超過1M！'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/contract.js